module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "not"
  }, [_vm._v("404, Not Found.")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-95845b4e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = 341
// module chunks = 1